import { useEffect } from "react";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { checkMaintenanceStatus } from "@/lib/maintenance";

export const Route = createFileRoute("/maintenance")({
  component: MaintenancePage,
});

function MaintenancePage() {
  const navigate = useNavigate();

  // Poll the always-available status endpoint; leave automatically when maintenance ends.
  useEffect(() => {
    let cancelled = false;
    const poll = async () => {
      const stillDown = await checkMaintenanceStatus();
      if (!cancelled && !stillDown) {
        navigate({ to: "/" });
      }
    };
    poll();
    const id = setInterval(poll, 30_000);
    return () => {
      cancelled = true;
      clearInterval(id);
    };
  }, [navigate]);

  return (
    <div className="min-h-screen bg-base-100 flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center space-y-6">
        <div className="text-7xl" aria-hidden="true">
          🛠️
        </div>
        <h1 className="text-3xl font-bold">We&apos;ll be right back!</h1>
        <p className="text-lg text-base-content/70">
          Booq is down for scheduled maintenance. Your points and progress are
          safe.
        </p>
        <p className="text-sm text-base-content/50">
          This page checks automatically — no need to refresh.
        </p>
        <span className="loading loading-dots loading-lg" aria-hidden="true" />
      </div>
    </div>
  );
}
